import { inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { Command, ConsoleLogger, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface EInvoiceReceivedReceiveXmlParams {
    readonly ksefReferenceNumber: string;
}

export type EInvoiceReceivedReceiveXmlResponse = boolean;

export class EInvoiceReceivedReceiveXmlCommand extends Command<EInvoiceReceivedReceiveXmlParams, EInvoiceReceivedReceiveXmlResponse> { }

@CommandHandlerFor(EInvoiceReceivedReceiveXmlCommand)
@Injectable({ providedIn: 'root'})
export class EInvoiceReceivedReceiveXmlCommandHandler {
    #Url = TaggedUrl.join('eInvoices/headers/:ksefReferenceNumber/receiveXml', [Tags.Api]);
    #logger = new ConsoleLogger(this.constructor.name);
    #http = inject(Http) as HttpService;

    public async handleAsync(cmd: EInvoiceReceivedReceiveXmlCommand): Promise<EInvoiceReceivedReceiveXmlResponse> {
        const { ksefReferenceNumber } = cmd.params!;
        const url = fillPlaceholders(this.#Url, { ksefReferenceNumber });

        try {
            await this.#http.post(url);
            return true;
        } catch(err) {
            this.#logger.error(err);
            return false;
        }
    }
}
